import React from "react";
import { Tooltip } from "@material-ui/core";
import { toDate, formatDateTime, localTimeZone } from "../../utils/waitingTime";

const ExactTime = ({ value, className, label = "Horário da mensagem" }) => {
  const date = toDate(value);
  if (!date) return null;
  const title = label + ": " + formatDateTime(date) + " · " + localTimeZone();
  return (
    <Tooltip title={title} arrow>
      <time className={className} dateTime={date.toISOString()} aria-label={title}>
        {formatDateTime(date)}
      </time>
    </Tooltip>
  );
};
export default ExactTime;
